import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Star } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;

export const ReviewDialog = ({ body, estCost, onClose, onDone }) => {
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(null);
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");
  const [polishing, setPolishing] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(`${API}/reviews`, { params: { sku: body.sku || "" } }).then((r) => setItems(r.data.items || [])).catch((e) => { setItems([]); toast.error(e.message); });
  }, [body.sku]);

  const choose = async (r) => {
    setSel(r); setAuthor(r.author); setQuote(r.text); setPolishing(true);
    try { const p = await axios.post(`${API}/reviews/polish`, { text: r.text }); setQuote(p.data.text); } catch { /* keep original */ }
    setPolishing(false);
  };
  const go = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/sessions/review`, { ...body, sku: sel.sku || body.sku, product_title: body.product_title || sel.product_name, quote, author }, { timeout: 90000 });
      toast.success("Creativul din recenzie se generează — ~1 minut");
      onDone(r.data); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="review-dialog" className="max-w-lg">
        <DialogHeader><DialogTitle>Creativ din recenzia unui client</DialogTitle></DialogHeader>
        {!body.sku && <p className="text-xs text-amber-700" data-testid="review-no-product">Nu ai ales un produs — afișez recenzii de 5★ de la toate produsele. Pozele selectate trebuie să fie ale produsului recenziei.</p>}
        <div className="max-h-56 space-y-2 overflow-y-auto pr-1" data-testid="review-list">
          {items === null && <Loader2 className="h-4 w-4 animate-spin text-zinc-400" />}
          {items?.length === 0 && <p className="text-sm text-zinc-500" data-testid="review-empty">Nu există recenzii de 5★ pentru acest produs.</p>}
          {items?.map((r) => (
            <button key={r.id} data-testid={`review-item-${r.id}`} onClick={() => choose(r)}
              className={`block w-full rounded-lg border p-2.5 text-left text-xs transition-colors ${sel?.id === r.id ? "border-amber-500 bg-amber-50" : "border-zinc-300 hover:border-zinc-500"}`}>
              <span className="flex items-center gap-1 text-amber-400">{[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-3 w-3 fill-current" />)}<span className="ml-1 text-zinc-500">{r.author} · {r.date}{!body.sku ? ` · ${r.sku}` : ""}</span></span>
              <span className="mt-1 block text-zinc-800">{r.text}</span>
            </button>
          ))}
        </div>
        {sel && (
          <div className="space-y-2">
            <p className="text-xs text-zinc-500">{polishing ? "Corectez diacriticele…" : "Textul care apare pe imagine (îl poți modifica):"}</p>
            <Textarea data-testid="review-quote-input" value={quote} onChange={(e) => setQuote(e.target.value)} rows={3} disabled={polishing} />
            <Input data-testid="review-author-input" value={author} onChange={(e) => setAuthor(e.target.value)} placeholder="Prenume client" />
          </div>
        )}
        <button data-testid="review-generate-btn" onClick={go} disabled={!sel || busy || polishing || !quote.trim()}
          className="flex items-center justify-center gap-2 rounded-full bg-amber-400 py-2.5 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Star className="h-4 w-4" />} Generează creativul · ~${estCost.toFixed(2)}
        </button>
      </DialogContent>
    </Dialog>
  );
};
